import { createContainer } from 'awilix';

export const diContainer = createContainer();
